export default function users(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                user: action.user,
            }
        default:
            return state;
    }
}
